/**
 * Converts a USD dollar value into an integer cent value.
 *
 * - Accepts `number`, `string`, or `null/undefined`
 * - Returns integer like 1999 (from "19.99" or 19.99)
 * - Falls back to `null` if the input is invalid or missing
 */
export const convertPriceFromDollarsToCents = (
  dollars: number | string | null | undefined
): number | null => {
  // Guard against null, undefined, or falsy values (except zero)
  if (!dollars && dollars !== 0) return null;

  // Coerce string or number into a number
  const valueInDollars = Number(dollars);
  if (Number.isNaN(valueInDollars)) return null;

  // Math.round, not Math.trunc: 20.06 * 100 is 2005.9999… in floating point and trunc drops a cent (FEL-3460)
  return Math.round(valueInDollars * 100);
};
